var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogProxy)?_c('x-dialog',{ref:"dialogProxyComp",attrs:{"proxy":_vm.dialogProxy}},[_vm._t("default"),_vm._t("footer")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }